import window from 'window-or-global';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';
import { CONTEXT_PATH } from '@confluence-classic/confluence-urls';
// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import idx from 'idx';
import { cfetch } from '@confluence/network';
import { EDIT_PAGE_V2, VIEW_PAGE } from '@confluence/named-routes';

const getIsFabricQueryBody = (variables) =>
	JSON.stringify({
		operationName: 'CheckIfFabric',
		variables,
		query: `
      query CheckIfFabric ($contentId: ID) {
        content(id: $contentId) {
          nodes {
            metadata {
              simple {
                isFabric
              }
            }
          }
        }
      }
    `,
	});

function testIfFabric(contentId) {
	return cfetch('/cgraphql?q=CheckIfFabric', {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			'X-APOLLO-OPERATION-NAME': 'CheckIfFabric',
		},
		body: getIsFabricQueryBody({ contentId }),
	});
}

function ConfluencePaste() {
	const self = this;

	const addAnchorSuffix = function (linkString, uri, fabricAnchor) {
		if (!uri.anchor || uri.anchor.indexOf('comment-') === 0) {
			// Ignore anchors for focused comments; they're handled by the $ wiki markup.
			return linkString;
		}

		return fabricAnchor
			? `${linkString}#${fabricAnchor}`
			: `${linkString}#${uri.anchor.substring(uri.anchor.indexOf('-') + 1)}`;
	};

	const displayPasteHandler = function (uri, linkString, parts) {
		if (parts.length === 2 && parts[1].indexOf('~') === 0) {
			//http://localhost:8080/confluence/display/~admin
			linkString = parts[1];
		} else if (parts.length === 3) {
			//http://localhost:8080/confluence/display/ds/Home
			linkString = `${parts[1]}:${parts[2].replace(/\+/g, ' ')}`;
			linkString = addAnchorSuffix(linkString, uri);
		} else if (parts.length === 4 && parts[1] === 'status') {
			//http://localhost:8080/confluence/display/status/admin/1212424
			linkString = `$${parts[3]}`;
		} else if (parts.length === 6) {
			//http://localhost:8080/confluence/display/ds/2011/10/27/jwafej+again+dog
			linkString =
				`${parts[1]}:` + `/${parts[2]}/${parts[3]}/${parts[4]}/${parts[5].replace(/\+/g, ' ')}`;
			linkString = addAnchorSuffix(linkString, uri);
		}
		return linkString;
	};

	const spacePasteHandler = function (uri, linkString, parts) {
		if ((parts.length === 2 || parts.length === 3) && parts[1].indexOf('.action') === -1) {
			//http://localhost:8080/confluence/spaces/:space/[overview|pages|...]
			linkString = `${parts[1]}:` + '';
			linkString = addAnchorSuffix(linkString, uri);
		}
		return linkString;
	};

	/*
   CEMS-512:
   pasteHandler has been modified to alter the anchor it gets back from the monolith when the URL points to a Fabric page.
   The returned value was altered instead of altering the monolith code because the monolith endpoint that returns the anchor is used by multiple other areas of the codebase.
   */
	const pasteHandler = function (uri, node, done) {
		if (!isConfluence(uri)) {
			done();
			return;
		}

		// Get contentId and check if a fabric page.  If it is, don't mangle it.
		const isEditOrViewPage = EDIT_PAGE_V2.match(uri.path) || VIEW_PAGE.match(uri.path);
		if (isEditOrViewPage) {
			testIfFabric(isEditOrViewPage.params.contentId)
				.then(async (res) => {
					const response = await res.json();
					const isFabric = Boolean(
						idx(response.data, (_) => _.content.nodes[0].metadata.simple.isFabric),
					);

					if (isFabric) {
						shortenTinyLink(uri, node, done, uri.anchor);
					} else {
						shortenTinyLink(uri, node, done);
					}
				})
				.catch((err) => {
					throw new Error(`Error retrieving content type: ${err}`);
				});
		} else {
			shortenTinyLink(uri, node, done);
		}
	};

	const shortenTinyLink = function (uri, node, done, fabricAnchor) {
		const stripContextPath = function (uri) {
			return CONTEXT_PATH ? uri.path.substring(CONTEXT_PATH.length + 1) : uri.path.substring(1);
		};

		const path = stripContextPath(uri);
		const parts = decodeURIComponent(path).split('/');
		let linkString;

		// All URIs provided by the parseUri function should have *at least* an empty queryKey object but we'll guard
		// anyway.
		uri.queryKey = uri.queryKey || {};

		if (uri.queryKey.focusedCommentId) {
			//http://localhost:8080/confluence/display/ds/Home&focusedCommentId=1212425#comment-1212425
			//http://localhost:8080/confluence/pages/viewpage.action?pageId=32784&focusedCommentId=1212425#comment-1212425
			linkString = `$${uri.queryKey.focusedCommentId}`;
			// HACK - although the anchor may be added it is currently ignored by the wiki converter.
			// In fact the "$12345" comment linkString above will be converted to a hard href, see CONF-24415.
			linkString = addAnchorSuffix(linkString, uri);
		} else if (uri.queryKey.pageId) {
			//http://localhost:8080/confluence/pages/viewpage.action?pageId=32784
			linkString = `$${uri.queryKey.pageId}`;
			linkString = addAnchorSuffix(linkString, uri);
		} else if (parts[0] === 'display') {
			linkString = displayPasteHandler(uri, linkString, parts);
		} else if (parts[0] === 'spaces') {
			linkString = self.spaViewPageLinkHandler(parts);
			linkString = linkString || self.spaBlogPostLinkHandler(parts);
			linkString = linkString
				? addAnchorSuffix(linkString, uri, fabricAnchor)
				: spacePasteHandler(uri, linkString, parts);
		}

		if (!linkString) {
			// Nothing matches this Confluence URI, leave it alone.
			done();
			return;
		}

		linkString = `[${linkString}]`;

		// This call hits an endpoint in the monolith that generates the tiny anchor in the editor
		// The new anchor node from the monolith is in the 'data' variable which is passed into the function
		// We override this for fabric targets (fabricAnchor !== "undefined")
		window.tinymce.plugins.Autoconvert.getHtmlFromWikiMarkup(
			linkString,
			(data) => {
				if (fabricAnchor) {
					// Encode the visible part of the link for readability
					const linkIsToCurrentPage = data.match(/href="#/);
					if (linkIsToCurrentPage) {
						// only the fragment is to be displayed, encode fragment
						// This is replacing the node text, "data-base-url" is just an anchor to find it with regex
						data = data.replace(
							/(data-base-url=".*">)(.*)(<\/a><\/p>)$/,
							`$1${decodeURIComponent(fabricAnchor)}$3`,
						);
					} else {
						// Base and fragment to be displayed, encode only the fragment
						// We have to get the page name from the dataLinkedResourceDefaultAlias minus the dataAnchor, then attach the decoded fabricAnchor
						const dataAnchor = data.match(/(data-anchor=")([^"]*)(" )/)[2];
						const dataLinkedResourceDefaultAlias = data.match(
							/(data-linked-resource-default-alias=")([^"]*)(" )/,
						)[2];
						const dataAnchorIndex = dataLinkedResourceDefaultAlias.lastIndexOf(dataAnchor);
						const newNodeText =
							dataLinkedResourceDefaultAlias.substring(0, dataAnchorIndex) +
							decodeURIComponent(fabricAnchor);

						// This is replacing the node text, "data-base-url" is just an anchor to find it with regex
						data = data.replace(/(data-base-url=".*">)(.*)(<\/a><\/p>)$/, `$1${newNodeText}$3`);
					}
					// Replace Tiny mangled versions of the fragment in the href with the fabric version
					data = data.replace(/(href="[^#]*#)([^"]*)(" )/, `$1${fabricAnchor}$3`);
					// Replace the data-linked-resource-default-alias attribute
					data = data.replace(
						/(data-linked-resource-default-alias=")([^"]*)(" )/,
						`$1${fabricAnchor}$3`,
					);
					// Replace the data-anchor attribute
					data = data.replace(/data-anchor="(.*?)"/, `data-anchor=\"${fabricAnchor}\"`);
				}

				done($(data).children()[0]);
			},
			() => {
				done();
			},
		);
	};

	const isConfluence = function (uri) {
		let isConfluence = true;

		isConfluence = isConfluence && uri.authority === document.location.host;

		isConfluence = isConfluence && (!CONTEXT_PATH || uri.path.indexOf(CONTEXT_PATH) === 0);

		return isConfluence;
	};

	this.init = function () {
		window.tinymce.plugins.Autoconvert.autoConvert.addHandler(pasteHandler);
	};
}

/**
 * Check parts of pasted URL is SPA View Page link or not.
 * SPA View Page link looks like:
 *   http://localhost:8080/wiki/spaces/TES1/pages/1234/hello+world
 * SPA Edit Page link looks like:
 *   http://localhost:8080/wiki/spaces/TES1/pages/edit/1234?draftId=123&draftShareId=12ef-34cd-56ab
 *
 * @param {Array} parts - not include context path and split by '/',
 * example: ['spaces', 'TES1', 'pages', '1234', 'hello+world']
 *
 * @return {(string|undefined)} link string contains '$' and pageId, ex: '$1234'
 */
ConfluencePaste.prototype.spaViewPageLinkHandler = function (parts) {
	const isSPAViewPageLink = parts[0] === 'spaces' && parts[2] === 'pages';
	const pageId = parts[3] === 'edit' ? parts[4] : parts[3];

	if (isSPAViewPageLink && pageId) {
		return `$${pageId}`;
	}
};

/**
 * Check parts of pasted URL is SPA Blog Post link or not.
 * SPA blog post link looks like: http://localhost:8080/wiki/spaces/TES2/blog/2016/10/21/1234/test+blog+post+1
 *
 * @param {Array} parts - not include context path and split by '/',
 * example: ['spaces', 'TES1', 'blog', '2016', '10', '21', '1234', 'test+blog+post+1' ]
 *
 * @return {(string|undefined)} link string contains '$' and blog post id, ex: '$123'
 */
ConfluencePaste.prototype.spaBlogPostLinkHandler = function (parts) {
	const isSPABlogPostLink = parts[0] === 'spaces' && parts[2] === 'blog';
	const spaceKey = parts[1];
	const year = parts[3];
	const month = parts[4];
	const date = parts[5];
	const blogId = parts[6];
	const slug = parts[7];

	if (isSPABlogPostLink && spaceKey && year && month && date && blogId && slug) {
		return `${spaceKey}:$${blogId}/${year}/${month}/${date}/${slug.replace(/\+/g, ' ')}`;
	}
};

export default function () {
	const confluencePaste = new ConfluencePaste();
	bind('init.rte', confluencePaste.init);
}
